// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Modal - Minimal styling for maximum flexibility
 */

.realm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: realm-modal-overlay-fade-in 0.2s ease-out;
}

@keyframes realm-modal-overlay-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.realm-modal-content {
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: realm-modal-enter 0.3s ease-out;
}

@keyframes realm-modal-enter {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .realm-modal-content {
    background: #1f1f1f;
    color: #ffffff;
  }
}

/* Modal sizes */
.realm-modal-sm {
  width: 90%;
  max-width: 400px;
}

.realm-modal-md {
  width: 90%;
  max-width: 500px;
}

.realm-modal-lg {
  width: 90%;
  max-width: 700px;
}

/* Scrollbar styling */
.realm-modal-content::-webkit-scrollbar {
  width: 6px;
}

.realm-modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.realm-modal-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

@media (prefers-color-scheme: dark) {
  .realm-modal-content::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .realm-modal-content {
    padding: 16px;
    margin: 16px;
  }

  .realm-modal-sm,
  .realm-modal-md,
  .realm-modal-lg {
    width: calc(100% - 32px);
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../packages/common/realm-ui/components/Modal.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA,gBAAgB;AAChB;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE,oCAAoC;EACtC;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;;;IAGE,wBAAwB;IACxB,eAAe;EACjB;AACF","sourcesContent":["/**\n * Modal - Minimal styling for maximum flexibility\n */\n\n.realm-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: realm-modal-overlay-fade-in 0.2s ease-out;\n}\n\n@keyframes realm-modal-overlay-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.realm-modal-content {\n  position: relative;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 24px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  animation: realm-modal-enter 0.3s ease-out;\n}\n\n@keyframes realm-modal-enter {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .realm-modal-content {\n    background: #1f1f1f;\n    color: #ffffff;\n  }\n}\n\n/* Modal sizes */\n.realm-modal-sm {\n  width: 90%;\n  max-width: 400px;\n}\n\n.realm-modal-md {\n  width: 90%;\n  max-width: 500px;\n}\n\n.realm-modal-lg {\n  width: 90%;\n  max-width: 700px;\n}\n\n/* Scrollbar styling */\n.realm-modal-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.realm-modal-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.realm-modal-content::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n\n@media (prefers-color-scheme: dark) {\n  .realm-modal-content::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.2);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .realm-modal-content {\n    padding: 16px;\n    margin: 16px;\n  }\n\n  .realm-modal-sm,\n  .realm-modal-md,\n  .realm-modal-lg {\n    width: calc(100% - 32px);\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
